export default __webpack_public_path__ + "static/media/mba-leader-man-v1.91696c7e.png";